import React, { useEffect } from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { isEmpty } from "@ui-seeker/utils"


export default function TimeFromSelector() {

	const {
		timeFrom,
		setTimeFromInfo,
		error
	} = useReportFormInfo(reportFormData.peek().timeFrom, "timeFrom", object({ timeFrom: string().required("Must provide a start hour") }))

	useEffect(() => {
		if (!timeFrom && !isEmpty(reportFormData.value)) setTimeFromInfo("10:00")
	}, [timeFrom])

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setTimeFromInfo("10:00", false)
		}
	}, [useCsv.value])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Pickup Time"
		placeholder="Pickup Time"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/hours`}
		value={timeFrom}
		onChange={e => setTimeFromInfo(e.target.value)}
		error={error}
	/>
}

